import templateUrl from "emun.order/modify-order/modify-order-prompt.htm";
import controller from "emun.order/modify-order/modify-order-prompt.controller";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import ContactPrompt from "emun.customer/contact-prompt";
import config from "emun.retailer/retailer.config";
import authConfig from "emun.auth/auth.config";
import registerRetailerPromptFormIO from "emun.auth/register-retailer.prompt";
import registerRetailerPrompt from "emun.auth/register-retailer-prompt";
import scss from 'emun.order/order-details-prompt.scss';
import orderConfig from "emun.order/order.config";

const done = () => null;

const reject = (failed = {}) => {
	if (failed.createCustomer) {
		if (authConfig.registrationCRM) {
			if (authConfig.formIORegistration) {
				registerRetailerPromptFormIO({}).then(
					retailer => {
						const retailerId = retailer.meta.RetailerId || retailer.id;
						modifyOrderPrompt({
							model: Object.assign(failed.createCustomer, {
								retailerId,
								retailer: {
									id: retailerId,
									companyName: retailer.companyName
								}
							})
						});
					},
					() => modifyOrderPrompt({ model: failed.createCustomer })
				);
			} else {
				registerRetailerPrompt({}).then(
					retailer => {
						const retailerId = retailer.meta.RetailerId || retailer.id;
						modifyOrderPrompt({
							model: Object.assign(failed.createCustomer, {
								retailerId,
								retailer: {
									id: retailerId,
									companyName: retailer.companyName
								}
							})
						});
					},
					() => modifyOrderPrompt({ model: failed.createCustomer })
				);
			}
		} else if (config.quickStartCustomer) {
			resolve("retailerPrompt")
				.start()
				.then(
					retailer => {
						const retailerId = retailer.meta.RetailerId || retailer.id;
						modifyOrderPrompt({
							model: Object.assign(failed.createCustomer, {
								retailerId,
								retailer: {
									id: retailerId,
									companyName: retailer.companyName
								}
							})
						});
					},
					() => modifyOrderPrompt({ model: failed.createCustomer })
				);
		} else {
			resolve("retailerPrompt")
				.add()
				.then(
					retailer => {
						const retailerId = retailer.meta.RetailerId || retailer.id;
						modifyOrderPrompt({
							model: Object.assign(failed.createCustomer, {
								retailerId,
								retailer: {
									id: retailerId,
									companyName: retailer.companyName
								}
							})
						});
					},
					() => modifyOrderPrompt({ model: failed.createCustomer })
				);
		}
	} else if (failed.createShippingLocation) {
		resolve("retailerShippingLocationPrompt")
			.add(failed.createShippingLocation)
			.then(
				loc =>
					modifyOrderPrompt({
						model: Object.assign(failed.createShippingLocation, {
							retailerId: loc.retailerId,
							shippingLocationId: loc.id,
							shippingLocation: loc
						})
					}),
				() => modifyOrderPrompt({ model: failed.createShippingLocation })
			);
	} else if (failed.createContact) {
		ContactPrompt.open({
			model: { customer: failed.createContact.retailer }
		}).then(
			con =>
				modifyOrderPrompt({
					model: Object.assign(failed.createContact, {
						buyer: con.contact.name
					})
				}),
			() => modifyOrderPrompt({ model: failed.createContact })
		);
	}
};

export const modifyOrderPrompt = options => {
	const prom = modals.open(
		Object.assign(
			{
				size: "md",
				templateUrl,
				resolve: {
					options: () => options
				},
				bindToController: true,
				controller,
				controllerAs: "$ctrl"
			},
			(options || {}).modal
		)
	).result;

	prom.then(done, reject);

	return prom;
};

export default { open: modifyOrderPrompt };
